import $ from 'jquery';
import './slick-carousel';
import _get from "lodash/get";
import customPaging from './slick/custom-paging';
import createCounter from './slick/counter';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import throttle from 'lodash/throttle';
// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'slickSlider';
export const STATUS_CLASS = 'js-slides-status';
export const DEFAULTS = {
    infinite: false,
    accessiblePaging: false,
    hasQuickview: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [],
    lazyLoad: 'ondemand',
    type: '',
    rtl: _get(window, 'rcProps.isRtl', false),
	showStatus: false,
};
let slickID = 1;

/**
 * Merges together all the options and the various conditions in which they
 * can be set.
 * @param  {jQuery} $el - The container element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options
 */
const mergeOptions = ($el, $carouselPrevHTML, $carouselNextHTML, options = {}) => {
	let customPagingOpt = {};
	if(options.accessiblePaging) {
    customPagingOpt = { customPaging }
	}

	const updateOpts = {
    nextArrow: $carouselNextHTML,
    prevArrow: $carouselPrevHTML,
  }

  let opts = $.extend({}, DEFAULTS, $el.data(), updateOpts, customPagingOpt, options );
  
return opts;
};

const initSlick = ($carouselTrack, options = {}) => {
	if (options.showStatus) {
		createCounter($carouselTrack);
	}
	$carouselTrack.on('afterChange', function(event, slick, currentSlide){
		const carouselEvent = new CustomEvent('carouselChange');
		carouselEvent.tracking = {
			type: options.type,
			currentSlide: currentSlide,
			pageUrl: window.location.href,
			pageTitle: document.title,
			element : $(this)
		};
		window.dispatchEvent(carouselEvent);
	});
	  $carouselTrack.slick(options);
};

const getViewportBottomFoldPos = () => {
    return $(window).scrollTop() + $(window).height();
}
const getSlickTopPos = ($el) => {
	if($el.length) {
		const slickPos = $el.offset();
		return slickPos.top;
	}
    return;
}
const checkSlickInit = ($el) => {
    return $el.hasClass('slick-initialized');
}

/**
 * Remove any sort of event handlers for the modal.
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 */
const destroySlick = ($carouselTrack) => {
	const isInitialized = $carouselTrack.hasClass('slick-initialized');
	if(isInitialized) {
		$carouselTrack.slick('unslick');
	}
};

/**
 * Remove any sort of event handlers for the modal.
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 */
const removeEventListeners = (thisSlickID) => {
  $(window).off(`scroll.slickslider${thisSlickID}`);
};


/**
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @param  {Function} deregister - teardown method from register jquery plugin
 */
const destroy = ($carouselTrack, thisSlickID, deregister) => {
  removeEventListeners(thisSlickID);
  destroySlick($carouselTrack);
  deregister();
};

// For slick carousels that have Quickviews, adds tabindex=-1 to .js-slick-no-focus elements
const checkForQuickview = ($el) => {
	$el.on('init', function (event, slick) {
		setTimeout(function(){
			slick.$slides.filter('.slick-active').find('.js-slick-no-focus').attr('tabindex', '-1');
      slick.$nextArrow.addClass('active');
      slick.$prevArrow.addClass('active');
		}, 200);
	});

	$el.on('afterChange', function(event, slick, currentSlide, nextSlide){
		setTimeout(function(){
			slick.$slides.filter('.slick-active').find('.js-slick-no-focus').attr('tabindex', '-1');
		}, 200);
	});
}
const checkScrollPosition = ($el, thisSlickID, $carouselTrack, options = {}) => {
    const offsetLazyLoad = 150;
    const viewportBottomFoldPos = getViewportBottomFoldPos();
    const slickTopPos = getSlickTopPos($carouselTrack);
    const isSlickInit = checkSlickInit($carouselTrack);
    if (slickTopPos < (viewportBottomFoldPos + offsetLazyLoad) && !isSlickInit) {
        $(window).off(`scroll.slickslider${thisSlickID}`);
        initSlick($carouselTrack, options);
    }
};
const setSlidesToShow = ($el, $carouselTrack, opts) => {
	let updateSlideNumber = opts.slidesToShow;
	$carouselTrack.on('init', function (event, slick){
		if(updateSlideNumber > 1) {
			$el.find('.slides-to-show').text(updateSlideNumber);
		}
	});
}

const getTrack = ($el) => $el.find(".js-carousel__track").css({'display':'block'});
const getPrev = ($el) => $el.find(".js-carousel__prev");
const getNext = ($el) => $el.find('.js-carousel__next');

export default function slickSlider(el, options = {}, { deregister } = noopActions) {
    const $el = $(el);
    const $carouselTrack = getTrack($el);
    const $carouselPrevHTML = getPrev($el);
    const $carouselNextHTML = getNext($el);
		const opts = mergeOptions($el, $carouselPrevHTML, $carouselNextHTML, options);
    const thisSlickID = slickID;
    checkForQuickview($carouselTrack);
		setSlidesToShow($el, $carouselTrack, opts);
    checkScrollPosition($el,thisSlickID, $carouselTrack, opts);
    $(window).on(`scroll.slickslider${thisSlickID}`, throttle(() => {
        checkScrollPosition($el, thisSlickID, $carouselTrack, opts);
	}, 50));
    slickID++;
		return {
			checkPosition: () => checkScrollPosition($el, thisSlickID, $carouselTrack, opts),
			destroy: () => destroy($carouselTrack, thisSlickID, deregister),
		};
}
// Expose the function as a jQuery plugin for ease of use
registerJQueryPlugin(PLUGIN_NAME, slickSlider);


// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/slick-slider.js